import { useCallback, useState } from 'react';
import { useHost } from '../../hooks';

export const useFacetsDialog = (): [boolean, () => void, () => void] => {
  const [isOpen, setIsOpen] = useState(false);
  const { blockScroll, unblockScroll } = useHost();

  const open = useCallback(() => {
    setIsOpen(true);
    blockScroll();
  }, [setIsOpen, blockScroll]);

  const close = useCallback(() => {
    setIsOpen(false);
    unblockScroll();
  }, [setIsOpen, unblockScroll]);

  return [isOpen, open, close];
};
